
import { defineComponent, PropType } from "vue";
import { AP } from "@/domain/model";

export default defineComponent({
  name: "APList",
  props: {
    aps: {
      type: Array as PropType<AP[]>,
      required: true,
    },
    selectedAP: {
      type: Object as PropType<AP>,
    },
  },
  methods: {
    onSelect(ap: AP) {
      this.$emit("select", { ap });
    },
  },
  computed: {
    selected(): (ap: AP) => boolean {
      return (ap: AP) => {
        return this.selectedAP?.mac === ap.mac;
      };
    },
  },
});
